<template>
    <div class="context-pairs-wrap">
        <div
            v-for="(intent) in intentsInContext"
            :key="intent.id"
        >
            <intent-group
                :category="category"
                :intent="intent"
                :utterances="utterances"
                :is-pattern-view="isPatternView"
                :wrapTopReachHeader="wrapTopReachHeader"
                :wrapBottomFromHeaderSpace="wrapBottomFromHeaderSpace"
                :scrollTop="scrollTop"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import intentGroup from '../intent/intent_group'

export default {
  components: { intentGroup },

  props: {
    category: Object,
    wrapTopReachHeader: Boolean,
    wrapBottomFromHeaderSpace: Number,
    scrollTop: Number,
    isPatternView: Boolean
  },

  computed: {
    ...mapState('knowledgebase', ['intents', 'utterances']),

    intentsInContext () {
      return _.filter(this.intents.value, intent =>
        intent.category === this.category.id || intent.application === this.category.id)
    }
  }
}
</script>

<style lang="scss" scoped>
    .context-pairs-wrap {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        border-left: solid 1px $or-grey;
        border-right: solid 1px $or-grey;

        div > div:not(:last-of-type) {
            border-bottom: solid 1px $or-grey;
        }
    }
</style>
